import { FunctionComponent } from 'react';
import { BinaryQuestionTemplate } from '@templates';
import { ErrorMessages } from '@types';
import { useBikesStore } from '@bikes/store/store';
import { binaryQuestionSchema, parseZodErrors } from '@utils';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RoutesList } from '@bikes/routes/Routes';
import { ZodError } from 'zod';
import { useHandleSubmit } from '@bikes/hooks/useHandleSubmit';
import { BikesPayload } from '../payload/Payload';

export const EmailConfirmationReport: FunctionComponent = () => {
  const navigate = useNavigate();
  const payload = BikesPayload();
  const { mutate, isPending } = useHandleSubmit();
  const { updateReceiveConfirmationEmail, receiveConfirmationEmail } =
    useBikesStore();
  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);
  const pageTitle = 'Do you want a confirmation email of your report?';

  const handleChange = (value: string) => {
    updateReceiveConfirmationEmail(value);
    setErrorMessages([]);
  };

  const updatePayload = () => {
    payload.ReporterObject.contact_details = null;
    return payload;
  };

  const handleClick = () => {
    try {
      binaryQuestionSchema().parse({
        receiveConfirmationEmail: receiveConfirmationEmail,
      });
      receiveConfirmationEmail.toLowerCase() === 'yes'
        ? navigate(RoutesList.YOUR_DETAILS)
        : mutate(updatePayload());
    } catch (error) {
      const validationErrors = parseZodErrors(error as ZodError);
      setErrorMessages(
        validationErrors.map((error: ErrorMessages) => ({
          ...error,
          href: error.path,
        })),
      );
    }
  };

  const buttonNext = {
    label: receiveConfirmationEmail.toLowerCase() === 'no' ? 'Submit' : 'Next',
    loading: isPending,
    onClick: handleClick,
  };

  const buttonPrevious = {
    onClick: () => navigate(RoutesList.TELL_US_MORE),
  };

  const options = [
    {
      labelText: 'Yes',
      isDefault: receiveConfirmationEmail === 'Yes',
    },
    {
      labelText: 'No',
      isDefault: receiveConfirmationEmail === 'No',
    },
  ];

  return (
    <BinaryQuestionTemplate
      title={pageTitle}
      options={options}
      onChange={handleChange}
      buttonNext={buttonNext}
      buttonPrevious={buttonPrevious}
      errorPath={'receiveConfirmationEmail'}
      errorMessages={errorMessages}
    />
  );
};
